module.exports = __webpack_public_path__ + "static/media/2-R-smart W-Mate.86d6e8ca.jpg";